import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BIT_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.BitPay,
    name: 'bitpay',
    displayName: 'BitPay'
};
